<template>
  <div id="home">
    <HomeList v-if="flag"></HomeList>
    <HomeUser v-else></HomeUser>
  </div>
</template>

<script>
//引入HomeFire Component
import HomeList from '@/views/home/HomeList'
//引入HomeUser Component
import HomeUser from '@/views/home/HomeUser'
export default {
  name: 'home',
  data(){
    return {
      flag: ""
    }
  },
  components: {
    HomeList,
    HomeUser
  },
  created(){
    if(this.CONSTANT.currentUser.deptid != null && (this.CONSTANT.currentUser.deptid == '90'|| this.CONSTANT.currentUser.deptid == '80' || this.CONSTANT.currentUser.deptid == '3')){
      this.flag = false;
    }else{
      this.flag = true;
    }
  }
}
</script>

<style>
html,body,#home{

 height: 100%;

}
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue